import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const CardsIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      enable-background='new 0 0 64 64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'
      fill={theme.palette.text.primary} height={props.width} width={props.width}
    >
      <g id='Layer_1' />
      <g id='Badge' />
      <g id='Basketball_Trophy' />
      <g id='Certificate_00000155142465879896954940000007463677100507110064_' />
      <g id='Star_Badge' />
      <g id='Police_Badge' />
      <g id='Flag' />
      <g id='Medal_00000057864904577975597920000015771584254612611517_' />
      <g id='Tophy_Award' />
      <g id='Medal_00000142146757898845982370000005096811746825199502_' />
      <g id='Certificate' />
      <g id='Star_Trophy' />
      <g id='Award' />
      <g id='Third_Position' />
      <g id='Second_Position'>
        <path
          d='m57.59 52.55-7.01-15.02c2.78-3.8 4.42-8.48 4.42-13.53 0-12.68-10.32-23-23-23s-23 10.32-23 23c0 5.05 1.64 9.73 4.42 13.53l-7.01 15.02c-.31.67-.23 1.45.22 2.04.44.59 1.17.89 1.9.78l9.37-1.43 4.93 8.1c.36.6 1.01.96 1.71.96h.11c.74-.04 1.39-.49 1.7-1.15l5.65-12.12 5.65 12.12c.31.66.96 1.11 1.7 1.15h.11c.7 0 1.35-.36 1.71-.96l4.93-8.1 9.37 1.43c.73.11 1.46-.19 1.9-.78.45-.59.53-1.37.22-2.04zm-44.59-28.55c0-10.48 8.52-19 19-19s19 8.52 19 19-8.52 19-19 19-19-8.52-19-19z'
        />
        <path
          d='m32 9c-8.27 0-15 6.73-15 15s6.73 15 15 15 15-6.73 15-15-6.73-15-15-15zm4.25 23h-8.5c-.892 0-1.675-.591-1.922-1.448-.246-.857.105-1.774.861-2.248 2.96-1.855 7.061-5.425 7.061-7.305 0-1.103-.897-2-2-2s-2 .897-2 2c0 1.104-.896 2-2 2s-2-.896-2-2c0-3.309 2.691-6 6-6s6 2.691 6 6c0 2.506-1.978 5.022-4.1 7h2.6c1.104 0 2 .896 2 2s-.896 2.001-2 2.001z'
        />
      </g>
      <g id='Winner' />
      <g id='Diploma' />
      <g id='Trophy' />
      <g id='Medal_00000005238149921129290700000016698065652002176917_' />
      <g id='Medal_00000142871562636648070520000015215049010245528497_' />
      <g id='Medal' />
    </svg>

  )
}
export default CardsIcon
